import {cloneElement} from "react"

import {useThreadDrawer} from "../ThreadDrawerContext"
import {ThreadDrawerTriggerProps} from "../threadDrawerTypes"

export const ThreadDrawerTrigger: React.FC<ThreadDrawerTriggerProps> = ({
  threadId,
  messageId,
  children,
}) => {
  const {showThread} = useThreadDrawer()

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    showThread(threadId, messageId)
  }

  return cloneElement(children as React.ReactElement, {
    onClick: handleClick,
    style: {
      cursor: "pointer",
      ...((children as React.ReactElement).props.style || {}),
    },
  })
}
